export const LIBRARY_COLUMNS_KEY = "matlib-library-columns";
export const LIBRARY_COLUMNS_EVENT = "matlib-library-columns";

export function readLibraryColumns() {
  try {
    return window.localStorage.getItem(LIBRARY_COLUMNS_KEY) === "4" ? 4 : 5;
  } catch {
    return 5;
  }
}

export function writeLibraryColumns(count) {
  const next = count === 4 ? 4 : 5;
  try {
    window.localStorage.setItem(LIBRARY_COLUMNS_KEY, String(next));
  } catch {
    // The grid still updates for this page view.
  }
  window.dispatchEvent(
    new CustomEvent(LIBRARY_COLUMNS_EVENT, { detail: next }),
  );
  return next;
}

export function toggleLibraryColumns() {
  return writeLibraryColumns(readLibraryColumns() === 5 ? 4 : 5);
}
